export enum ColumnMappingTableName {
  ENCOUNTER = 'Encounter-Level Data Mapping',
  LAB = 'Lab Results Data Mapping',
  COMBINED = 'Combined Encounter-Level and Lab Results Data Mapping',
}
